module.exports = __webpack_public_path__ + "img/cns_printer_pc9.80742294.png";